import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import StudentProgress from './StudentProgress';
import StudentStatistics from './StudentStatistics';
import TodayActivity from './TodayActivity';
import PassengerSummary from './PassengerSummary';
import WeeklyReport from './WeeklyReport';
import { io } from 'socket.io-client';
const socket = io('http://192.168.1.109:3012');

const Dashboard = () => {
    useEffect(() => {
        socket.on('message', (msg) => {
            console.log(msg);
        });
    },[])
    return (
        <>
            <Row className="g-3 mb-3">
                <Col sm={6} xxl={4}>
                    <StudentProgress/>
                </Col>
                <Col sm={6} xxl={4}>
                    <StudentStatistics/>
                </Col>
                <Col sm={6} xxl={4}>
                    <TodayActivity/>
                </Col>
            </Row>
            <Row className="g-3 mb-3">
                <Col sm={6} xxl={8}>
                    <PassengerSummary/>
                </Col>
                <Col sm={6} xxl={4}>
                    <WeeklyReport/>
                </Col>
            </Row>
        </>
    )
}

Dashboard.propTypes = {}

export default Dashboard;